/* eslint-disable react/prefer-es6-class, react/sort-comp */
import React from 'react';
import { ChoicesSessionSize } from 'es6/components/apps/choices';
import { humanizedTime } from 'es6/helpers/time';
import { t } from 'es6/services/localization';
import { ProgressBarSentenceTrainer } from 'es6/components/common/progress-bar';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import { Stats, Stat, StatData, StatLabel } from 'es6/components/apps/stats';
import { TranscodedImageSizes, TranscodedImage } from 'es6/components/common/transcoded-image';
import WelcomeSentenceTrainerMixin from 'es6/components/apps/mixins/welcome-sentence-trainer';

export default React.createClass({
  displayName: 'WelcomeSentenceTrainerCourseScreen',

  mixins: [WelcomeSentenceTrainerMixin],

  propTypes: {
    isCheckpoint: React.PropTypes.bool,
    onCheckpointSkip: React.PropTypes.func,
    onSessionSizeChange: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
    sessionConfig: React.PropTypes.object.isRequired,
    sessionData: React.PropTypes.object.isRequired,
    sessionSizes: React.PropTypes.array,
  },

  getDefaultProps() {
    return {
      isCheckpoint: false,
      onCheckpointSkip: null,
      sessionSizes: [5, 10, 20],
    };
  },

  render() {
    const sessionData = this.props.sessionData;
    const aggregateMemory = sessionData.aggregateMemories[0];
    const goal = sessionData.goals[0];

    return (
      <div className="screen screen-welcome-sentence-trainer screen-welcome-sentence-trainer-course">
        <div className="screen-content">
          <span className="loading-spinner"></span>

          <h1 className="title">
            {this.props.isCheckpoint ? t('checkpoint-label') : ''}
            {' '}
            {t('app-branding.sentence-trainer')}
          </h1>

          <div className="course-details">
            {this._renderCourseImage()}

            <div className="course-details-inner">
              <div className="title-level-container">
                <h2 className="course-title">{goal.title}</h2>
                <span className="level">{t('level-label')} {aggregateMemory.sentences.level}</span>
              </div>

              <ProgressBarSentenceTrainer progress={aggregateMemory.sentences.progress} />

              <Stats className="stats-inline">
                <Stat type="started">
                  <StatData>
                    {aggregateMemory.sentences.studiedItemsCount}
                    {' '}
                    <span className="secondary">/ {goal.sentencesCount}</span>
                  </StatData>
                  <StatLabel>{t('times')}</StatLabel>
                </Stat>

                <Stat type="time">
                  <StatData>{humanizedTime(aggregateMemory.sentences.totalStudyTime)}</StatData>
                  <StatLabel>{t('js_iknow.study time')}</StatLabel>
                </Stat>
              </Stats>
            </div>
          </div>

          <div className="next-session">
            <div className="session-config">
              <label className="choice-label">
                {t('sentence-trainer.session-size')}
              </label>

              <ChoicesSessionSize sizes={this.props.sessionSizes} sessionConfig={this.props.sessionConfig} onChange={this.props.onSessionSizeChange} className="choice-set-expanded" />
            </div>

            {this._renderSessionDetails()}
          </div>
        </div>

        {this.props.isCheckpoint ? this._renderCheckpointNavigation() : this._renderNavigation()}
      </div>
    );
  },

  _renderCheckpointNavigation() {
    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onCheckpointSkip} className="btn-danger">{t('checkpoint-skip')}</NavButton>
        <NavButton align="right" focused onClick={this.props.onStart}>{t('start')}</NavButton>
      </Navigation>
    );
  },

  _renderCourseImage() {
    const goal = this.props.sessionData.goals[0];

    if (!goal.icon) {
      return null;
    }

    return (
      <TranscodedImage className="course-image" src={goal.icon} size={TranscodedImageSizes.LARGE} />
    );
  },
});
